import connectConfigure from "instantsearch.js/es/connectors/configure/connectConfigure.js";
import { useConnector } from "../hooks/useConnector.js";
export function useConfigure(props, additionalWidgetProperties) {
  return useConnector(connectConfigure, {
    searchParameters: props
  }, additionalWidgetProperties);
}